var render, staticRenderFns
import script from "./dashboardChart.vue?vue&type=script&lang=js&"
export * from "./dashboardChart.vue?vue&type=script&lang=js&"
import style0 from "./dashboardChart.vue?vue&type=style&index=0&id=6f12dbc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f12dbc0",
  null
  
)

export default component.exports